import React from 'react';
import styled from 'styled-components';
import {elevation, borderRadius} from '@atlaskit/theme';
import Button from '@atlaskit/button';
import {GridColumn, Grid} from '@atlaskit/page';
import {Link} from 'react-router-dom';
import ProgressBar from '@atlaskit/progress-bar';
import i18n from 'i18next';

export const FieldTitle = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: -0.1px;
  color: #6B778C;
  margin-top: 16px;
`;

export const FieldValue = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #172B4D;
`;

export const ViewFormField = ({gridColumn, label, value, emptyValue = '-'}) => (
  <GridColumn medium={gridColumn}>
    <FieldTitle>{label}</FieldTitle>
    <FieldValue>{value ? value : emptyValue}</FieldValue>
  </GridColumn>
) 

const EmptyContainer = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #172B4D;
  margin-top: 16px;
`;

export const EmptyMsg = ({msg}) => (
  <EmptyContainer>{msg}</EmptyContainer>
)

const Container = styled.div`
  position: relative;
  ${props => props.editMode && 'z-index: 510;'}
  display: block;
  margin: 32px 0px;
`;

const ChildrenContainer = styled.div`
  ${elevation['e100']}
  background-color: white;
  border-radius: ${borderRadius()}px;
  padding: 16px 24px;
  padding-top: 0px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;


const Title = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #172B4D;
`;

export const ListViewForm = ({
  title,
  formName,
  actions,
  data,
  children,
  ItemContainer,
  EmptyContainer,
  more,
  fetching,
}) => {
  return (
    <Container id={formName}>
      {title && actions && (
        <TitleWrapper>
          {title && (<Title>{title}</Title>)}
          <ButtonsWrapper>
            {actions && actions.map(action => (
              <Button
                key={`form_actions_${action.name}`}
                spacing='compact'
                onClick={action.onClick}
                appearance={action.appearance}
                isDisabled={fetching}
                style={{marginLeft: 8}}
              >
                {action.name}
              </Button>
            ))}
          </ButtonsWrapper>
        </TitleWrapper>
      )}
      <div>
        {fetching && <ProgressBar isIndeterminate/>}
        {data && data.length && ItemContainer
          ? data.map((itm, index) => <ItemContainer key={`form_list_${index}`} {...itm}/>)
          : EmptyContainer ? <EmptyContainer/> : null
        }
        {children}
      </div>
      {more && (
        <Button
          appearance='link'
          spacing='none'
          component={React.forwardRef((props, ref) => (
            <Link {...props} ref={ref} to={more.href}>
              {props.children}
            </Link>
          ))}
        >
          {more.name}
        </Button>
      )}
    </Container>
  )
}

export default ({title, formName, action, actionName, editMode, children, fetching}) => {
  return (
    <Container id={formName} editMode={editMode}>
      {(title || actionName) && (
        <TitleWrapper>
          {title && (<Title>{title}</Title>)}
          {actionName && (
            <Button 
              isDisabled={fetching}
              isLoading={fetching}
              spacing='compact' 
              onClick={action}
            >
              {editMode ? i18n.t('Close') : actionName}
            </Button>
          )}
        </TitleWrapper>
      )}
      <ChildrenContainer>
        <Grid>
          {children}
        </Grid>
      </ChildrenContainer>
    </Container>
  )
}
